import type { AdminQueryError } from "../../contracts/admin-query-errors";
import { pickAdminDashboardLocaleText } from "../locale/admin-dashboard-copy";
import type { AdminDashboardLocale } from "../locale/admin-dashboard-locale";

function messageForCode(
  code: AdminQueryError["code"],
  locale: AdminDashboardLocale,
): string {
  switch (code) {
    case "ADMIN_QUERY_PERMISSION_DENIED":
      return pickAdminDashboardLocaleText(locale, {
        en: "Admin query permission denied.",
        ko: "관리자 조회 권한이 없습니다.",
      });
    case "ADMIN_QUERY_INVALID_FILTER":
      return pickAdminDashboardLocaleText(locale, {
        en: "The current filter is invalid for this admin query.",
        ko: "현재 필터 조건이 관리자 조회 계약과 맞지 않습니다.",
      });
    case "ADMIN_QUERY_USER_NOT_FOUND":
      return pickAdminDashboardLocaleText(locale, {
        en: "The requested user could not be found in the admin read model.",
        ko: "요청한 사용자를 관리자 조회 모델에서 찾을 수 없습니다.",
      });
    case "ADMIN_QUERY_PROJECTION_STALE":
      return pickAdminDashboardLocaleText(locale, {
        en: "The admin projection is stale. Refresh the projection and retry the query.",
        ko: "관리자 프로젝션이 지연되었습니다. 프로젝션을 새로 고친 뒤 다시 조회하세요.",
      });
    case "ADMIN_QUERY_SOURCE_UNAVAILABLE":
      return pickAdminDashboardLocaleText(locale, {
        en: "The upstream admin source is unavailable right now. Retry after the source recovers.",
        ko: "상위 관리자 소스를 지금 읽을 수 없습니다. 소스가 복구된 뒤 다시 조회하세요.",
      });
    case "ADMIN_QUERY_REDACTION_FAILED":
      return pickAdminDashboardLocaleText(locale, {
        en: "The admin query result could not be redacted safely.",
        ko: "관리자 조회 결과를 안전하게 비식별화하지 못했습니다.",
      });
    case "ADMIN_QUERY_INTERNAL_ERROR":
    default:
      return pickAdminDashboardLocaleText(locale, {
        en: "The admin query failed unexpectedly.",
        ko: "관리자 조회가 예기치 않게 실패했습니다.",
      });
  }
}

export function localizeAdminQueryError(
  error: AdminQueryError,
  locale: AdminDashboardLocale,
): AdminQueryError {
  return {
    ...error,
    message: messageForCode(error.code, locale),
  };
}
